import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { useStore } from "zustand/index";

const STORAGE_KEY = "dune-raid-tour";

export type TourContext = "raid-list" | "raid-edit-created" | "raid-edit-running";

interface RaidTourState {
  /** Contexts the user has already seen (auto-start won't fire again). */
  seen: Record<string, boolean>;
  /** Which context tour is currently open (null = none). */
  activeContext: TourContext | null;

  markSeen: (ctx: TourContext) => void;
  start: (ctx: TourContext) => void;
  close: () => void;
  hasSeen: (ctx: TourContext) => boolean;
}

const raidTourStore = create<RaidTourState>()(
  persist(
    (set, get) => ({
      seen: {},
      activeContext: null,

      markSeen: (ctx) =>
        set((s) => ({ seen: { ...s.seen, [ctx]: true } })),

      start: (ctx) => set({ activeContext: ctx }),

      close: () => {
        const ctx = get().activeContext;
        if (ctx) {
          set((s) => ({
            activeContext: null,
            seen: { ...s.seen, [ctx]: true },
          }));
        } else {
          set({ activeContext: null });
        }
      },

      hasSeen: (ctx) => !!get().seen[ctx],
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ seen: s.seen }),
    },
  ),
);

export const useRaidTourStore = () => useStore(raidTourStore);
export { raidTourStore };
